import { connect } from 'react-redux';
import {
  NON_STRUCTURAL_RETROFIT_YEAR,
  STRUCTURAL_RETROFIT_YEAR,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/formInputNames.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import BuildingDesignInfoSection from './BuildingDesignInfoSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectFormFieldVisibility } = modelTypesByForm[form];
  return {
    structuralRetrofitYearIsVisible: selectFormFieldVisibility(state)(STRUCTURAL_RETROFIT_YEAR),
    nonstructuralRetrofitYearIsVisible: selectFormFieldVisibility(state)(
      NON_STRUCTURAL_RETROFIT_YEAR
    ),
  };
};

export default connect(mapStateToProps)(BuildingDesignInfoSection);
